import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import * as i0 from "@angular/core";
export class SharingModalModule {
}
SharingModalModule.ɵfac = function SharingModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SharingModalModule)(); };
SharingModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SharingModalModule });
SharingModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ConfirmModalModule,
        DisabledModule,
        FormsModule,
        LoadingSymbolModule,
        ModalBaseModule,
        SingleSelectDropdownModule] });
